import { useRepositorySuspenseQuery } from '@mews-commander/data-access';

export const useSuspenseCentralCancellationPolicyGet = (cancellationPolicyId: string) =>
    useRepositorySuspenseQuery(
        'portfolioCentralCancellationPolicies',
        'get',
        {
            centralCancellationPolicyId: cancellationPolicyId,
        },
        { select: ({ centralCancellationPolicy }) => centralCancellationPolicy }
    );
